const autoNgTemplateLoaderTemplate1 = require('./volumesnfsForm.html');

angular.module('shbdeployer.docker').component('volumesNfsForm', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    data: '=',
  },
});
